// extracted by mini-css-extract-plugin
module.exports = {"video":"D_7","wrapper":"D_f","btn":"D_bn","hide":"D_bP","play":"D_bQ"};